import { inject, provide, shallowRef, triggerRef } from "vue";
// Shared registry of rendered word <span> elements keyed by `${segmentId}:${wordIndex}`.
// The provider (TranscriptLayout) owns the Map; TranscriptMessage registers /
// unregisters each word as its template-ref callback fires. Lookup-only
// consumers (e.g. useTranscriptAutoScroll) read the Map at watch time so they
// don't have to query the DOM.
// Future perf pass: drop the per-word `:ref` arrow in favour of `data-word-id`
// + a single MutationObserver/scan from the provider — current call site
// allocates one closure per word per render.
export const TRANSCRIPT_WORD_ELEMENTS_KEY = Symbol();
export const initTranscriptWordElementsContext = () => {
    // Mutate the backing Map in place and notify via triggerRef; cloning per
    // register would allocate O(N) entries per word on a multi-thousand-word
    // transcript. Keep the backing reference in closure (not via `.value`) so
    // register isn't tracked as a dep of its caller's render effect.
    const backing = new Map();
    const wordElements = shallowRef(backing);
    const register = (id, el) => {
        if (el)
            backing.set(id, el);
        else
            backing.delete(id);
        triggerRef(wordElements);
    };
    provide(TRANSCRIPT_WORD_ELEMENTS_KEY, { wordElements, register });
    return { wordElements };
};
// Safe default: non-providing parents get a no-op so TranscriptMessage can
// still mount in isolation (e.g. in unit tests that don't exercise scrolling).
export const useTranscriptWordElementsContext = () => {
    return inject(TRANSCRIPT_WORD_ELEMENTS_KEY, {
        wordElements: shallowRef(new Map()),
        register: () => { }
    });
};
